import { Chip } from '@workwave-tidal/core/components'
import React, { useMemo } from 'react'

export const StatusChip: React.FC<{ status: string }> = ({ status }) => {
  const statusColor:
    | 'error'
    | 'success'
    | 'default'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'warning'
    | undefined = useMemo(() => {
    if (!status) return 'default'

    if (status.toLowerCase() === 'closed/won') {
      return 'success'
    }
    if (status.toLowerCase() === 'closed/lost') {
      return 'error'
    }

    return 'default'
  }, [status])

  const statusStyle = useMemo(
    () =>
      status.toLowerCase() === 'closed/lost'
        ? {
            '& .MuiChip-icon': { display: 'none' },
            backgroundColor: '#F7DAD5',
            color: '#2C4757',
            border: 'solid 1px #D63B1F',
          }
        : status.toLowerCase() === 'closed/won'
          ? {
              '& .MuiChip-icon': { display: 'none' },
              backgroundColor: '#DCF2E7',
              color: '#2C4757',
              border: 'solid 1px #47B882',
            }
          : {
              '& .MuiChip-icon': { display: 'none' },
              backgroundColor: 'rgba(9, 27, 42, 0.08)',
              color: '#2C4757',
              border: 'solid 1px #091B2A8F',
            },
    [status],
  )

  return (
    <Chip
      size="small"
      variant="filledOutline"
      label={`${status}`}
      color={statusColor}
      sx={{
        ...statusStyle,
        maxWidth: '150px',
        borderRadius: '4px',
        maxHeight: '20px',
      }}
    />
  )
}
